
import { CharConnectUtilitiesClass } from "@dndUtilities/char_connect_utilities_class";

const CharConnectUtilities = (function () {
  let instance: CharConnectUtilitiesClass;

  function createInstance() {
    const util = new CharConnectUtilitiesClass();
    return util;
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    }
  };
})();

export default CharConnectUtilities;
